import React from 'react';
import { MDBBtn } from 'mdbreact';
import './Button.css';

const ModelButtonField = ( props ) => {
    return(
        <div>
            <MDBBtn color={props.color} style={{
                borderRadius: '17px',
                fontSize: '0.9rem',
                width:'13%',
                float:'right',
                marginRight: '5%',
            }}
                rounded
                type='button'
                className='btn-block z-depth-1 col-md-4'
                onClick={props.submit}
            >
            {props.BName}
            </MDBBtn>
        </div>
    );
}

const ButtonField = ( props ) => {
    let btnCls = 'btn btn-outline-primary btn-rounded waves-effect';
    btnCls = (props.color == 'danger') ? 'btn btn-outline-danger btn-rounded waves-effect' : 'btn btn-outline-primary btn-rounded waves-effect';
    return (
        <button
            style={{ borderRadius: '15px',fontSize: '9px' }} 
            type="button" 
            className= { btnCls }
            disabled={props.disabled}
            onClick={props.submit}
            >{props.BName}</button>
    );
}

export default ButtonField;